import React from 'react';
import { Text, styled, Box } from '@/theme/index';

export const CSContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  padding: theme.spacing(1.5),
  marginBottom: theme.spacing(1),
  borderRadius: theme.spacing(0.25),
}));

export const CSHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
}));

export const CSOptions = styled(Box)(({ theme }) => ({
  paddingRight: theme.spacing(1.5),
  paddingLeft: theme.spacing(1.5),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(0.25),
}));

export const CSOptionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

export const CSOptionText = styled(Text)(({ theme }) => ({
  color: theme.palette.success.main,
  fontWeight: 'bold',
}));

interface CSOptionProps {
  icon: JSX.Element;
  title: string | JSX.Element;
  description?: string | JSX.Element;
  invertColors?: boolean;
}

export const CSOption = ({
  icon,
  title,
  description,
  invertColors,
}: CSOptionProps) => {
  return (
    <CSOptionContainer>
      <Box>{icon}</Box>
      <Box>
        {invertColors ? (
          <>
            <Text variant="body2">{title}</Text>
            <CSOptionText>{description}</CSOptionText>
          </>
        ) : (
          <>
            <CSOptionText>{title}</CSOptionText>
            <Text variant="body2">{description}</Text>
          </>
        )}
      </Box>
    </CSOptionContainer>
  );
};
